import { SeriesDashStyles, SeriesTypes, seriesDashStyles, seriesTypes } from "@/reducer/client-models";
import type { PlotSerieStyle } from "@/types/data";
import { t } from "@lingui/core/macro";
import { FormField } from "../../form-field";
import { ColorPickerInput } from "../LayerFormElements";

type SerieOptionsProps = {
  serieOptions?: PlotSerieStyle;
  onChange: (serieOptions: PlotSerieStyle) => void;
};

export function SerieOptions({ serieOptions, onChange }: SerieOptionsProps) {
  return (
    <>
      <ColorPickerInput
        label={t`Color`}
        change={(color) => {
          onChange({
            ...serieOptions,
            color,
          } as PlotSerieStyle);
        }}
        value={serieOptions?.color || "#FFFFFF"}
      />
      <FormField label={t`Series type`}>
        <select
          value={serieOptions?.type || seriesTypes[0]}
          onChange={({ target: { value } }) => {
            onChange({
              ...serieOptions,
              type: value,
            } as PlotSerieStyle);
          }}
        >
          {seriesTypes?.map((seriesType, idx) => (
            <option key={seriesType} value={seriesType}>
              {SeriesTypes[seriesType]}
            </option>
          ))}
        </select>
      </FormField>
      <FormField label={t`Line type`}>
        <select
          value={serieOptions?.dashStyle || seriesDashStyles[0]}
          onChange={({ target: { value } }) => {
            onChange({
              ...serieOptions,
              dashStyle: value,
            } as PlotSerieStyle);
          }}
        >
          {seriesDashStyles?.map((seriesDashStyle, idx) => (
            <option key={seriesDashStyle} value={seriesDashStyle}>
              {SeriesDashStyles[seriesDashStyle]}
            </option>
          ))}
        </select>
      </FormField>
    </>
  );
}
